export default {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#70C28C',
        accent: '#1CBFDF',
        secondary: '#447BBD',
        success: '#4A4FA1',
        info: '#4557A6',
        warning: '#F39B51',
        error: '#F35151',
      },
    },
    options: {
      customProperties: true,
    },
  }
};